import axios from 'axios'

export const fetchGuestDetails = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/fetchGuestPortalDetails.php', payload)
    .then(res => { 
        commit('setDetails', res.data)
    })
    .catch(error => {
        console.log(error)
        
    })

}

export const updateInvitationStatus = ({commit}, payload) => {

    axios.post('/customerPortal/guest/updateInvitationStatus.php', payload)
    .then(res => { 
        console.log(res.data)
    })
    .catch(error => {
        console.log(error)
        
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/events/actions.js